exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab-icon svg{display:inline-block;height:15px;width:15px;fill:#fff;stroke:#fff;vertical-align:middle}.match-icon svg{fill:none}.close-tab .close-label{padding-right:7px}.close-tab .tab-icon{display:inline-block;border:1px solid #fff}.close-tab .tab-icon svg{height:10px;width:10px!important;padding:5px}.tab-active{background:#c39c32}.customize-button svg{margin-top:10px;padding-top:0}.close-customize{width:21px;height:21px;margin-top:10px;margin-left:auto;margin-right:auto;border:2px solid #fff;border-radius:50%}.close-customize svg{margin-top:5px;width:11px;height:11px}.navigation-career{background:#d9ad37}.navigation-career .menu-left a{padding-top:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/components/tabs/tabs.styl
// module id = 15
// module chunks = 0 1